import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerAppNavigator } from '../utils/appNavigation';

/**
 * Registers React Router navigate for apiErrors / axios 403 handling.
 * Mount only when the user is authenticated (inside BrowserRouter).
 */
const AppNavigationBridge: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    registerAppNavigator((to, options) => navigate(to, options));
    return () => registerAppNavigator(null);
  }, [navigate]);

  return null;
};

export default AppNavigationBridge;
